import { useEffect } from "react";

interface DocumentMeta {
  title: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

function setMetaTag(property: string, content: string, isOg = false) {
  const attr = isOg ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta(meta: DocumentMeta) {
  useEffect(() => {
    document.title = meta.title;

    if (meta.description) {
      setMetaTag("description", meta.description);
    }
    if (meta.ogTitle) {
      setMetaTag("og:title", meta.ogTitle, true);
    }
    if (meta.ogDescription) {
      setMetaTag("og:description", meta.ogDescription, true);
    }
    if (meta.ogImage) {
      setMetaTag("og:image", meta.ogImage, true);
    }
  }, [meta.title, meta.description, meta.ogTitle, meta.ogDescription, meta.ogImage]);
}
